import PropTypes from 'prop-types';
import styles from './PlatformNoticeStatus.module.scss';

const PLATFORM_NOTICE_STATUS_VARIANTS = {
    confirmed: 'confirmed',
    proposed: 'proposed'
};

const getStatusVariant = (status) => {
    const normalizedStatus = status.trim().toLowerCase();

    return PLATFORM_NOTICE_STATUS_VARIANTS[normalizedStatus] || 'default';
};

const PlatformNoticeStatus = ({ status }) => {
    const statusVariant = getStatusVariant(status);

    return (
        <strong className={['govuk-tag', styles.status, styles[statusVariant]].join(' ')}>
            {status}
        </strong>
    );
};

PlatformNoticeStatus.propTypes = {
    status: PropTypes.string.isRequired
};

export default PlatformNoticeStatus;
